<template>
  <div
      class="category-list__item"
      :style="categoryStyle"
      @click="$emit('CategorySelected', category)"
  >
    <div
        class="category-list__item__description"
        :style="labelStyle"
    >
      {{category.DESCRIPCION}}
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      category: {type: Object},
    },
    computed: {
      labelStyle() {
        const {IMAGENURL} = this.category
        return IMAGENURL && {
          backgroundColor: 'rgba(52, 58, 64, .82)',
          bottom: 0,
          color: 'white',
          fontWeight: 'normal',
          left: 0,
          right: 0,
          padding: '.2rem .4rem',
          position: 'absolute',
        }
      },
      categoryStyle() {
        const {COLORFONDO, COLORTEXTO, IMAGENURL} = this.category

        if (IMAGENURL) return {
          background: `#bebebe url(${IMAGENURL}) center center`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }

        var colorFondo = '#' + this.getColor(Number(COLORFONDO))
        var colorTexto = '#' + this.getColor(Number(COLORTEXTO))

        if (colorFondo === '#000000') colorFondo = COLORFONDO
        if (colorTexto === '#000000') colorTexto = COLORTEXTO

        return {
          backgroundColor: colorFondo,
          color: colorTexto,
        }
      },
    },
    methods: {
      getColor: (int) => {
        let red = int >> 16
        let green = int - (red << 16) >> 8
        let blue = int - (red << 16) - (green << 8)
        let bin = blue << 16 | green << 8 | red
        return (function (h) {
          return new Array(7 - h.length).join('0') + h
        })(bin.toString(16).toUpperCase())
      },
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/Categories/CategoryListItem.vue